import { z } from 'zod';

/** As 27 UFs, na mesma ordem do backend (`dto/auth.dto.ts`). */
export const UFS = [
  'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG',
  'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO',
] as const;

/**
 * A V1 não validava nada: só `required` no HTML e checagem imperativa dentro do
 * `handleSubmit`. Aqui o formulário nem chama a API com dado inválido.
 */
export const loginEmailSchema = z.object({
  tipo: z.literal('email'),
  email: z.email('Informe um e-mail válido'),
  senha: z.string().min(1, 'Informe a senha'),
});

export const loginCrmvSchema = z.object({
  tipo: z.literal('crmv'),
  crmv: z.string().min(1, 'Informe o número do CRMV'),
  ufCrmv: z.enum(UFS, 'Selecione a UF'),
  senha: z.string().min(1, 'Informe a senha'),
});

export const loginSchema = z.discriminatedUnion('tipo', [loginEmailSchema, loginCrmvSchema]);

export type LoginForm = z.infer<typeof loginSchema>;
export type TipoLogin = LoginForm['tipo'];
